'use strict';

const {creatorById} = require('dibs-endpoints');
const {addHeaders, fetchWrapper} = require('dibs-service-fetch-wrappers/dist/util');

function fetchCreators(ac, {creatorIds}, done) {
    if (creatorIds && creatorIds.length) {
        const requests = creatorIds.map(creatorId => fetchWrapper(
            creatorById(creatorId),
            addHeaders({method: 'get'})
        ));

        Promise.all(requests)
            .then(responses => {
                ac.dispatch('ADD_CREATORS', responses.map(({result}) => result));
                done();
            }).catch(done);
    }
}

module.exports = {
    fetchCreators
};



// WEBPACK FOOTER //
// ./assets/js/global/actions/creatorsActions.es.js